// Direct file URLs are required: public object storage does not list folders.
// Each clip supports { src, start (seconds), duration (seconds), fit }.
// 'contain' shows the full frame at its original proportions.
// Clips are shuffled once on page load and rotate without immediate repeats.
export const HOME_VIDEO_CLIPS = [
  {
    src: 'https://pub-31f3fe711bc94b628336fabf982e45f8.r2.dev/home-video/movie1.mov',
    fit: 'cover',
    start: 0,
    duration: 9,
  },
  {
    src: 'https://pub-31f3fe711bc94b628336fabf982e45f8.r2.dev/home-video/movie2.mp4',
    fit: 'cover',
    start: 0,
    duration: 9,
  },
  {
    src: 'https://pub-31f3fe711bc94b628336fabf982e45f8.r2.dev/home-video/movie3.mov',
    fit: 'cover',
    start: 0,
    duration: 9,
  },
  {
    src: 'https://pub-31f3fe711bc94b628336fabf982e45f8.r2.dev/home-video/movie4.mp4',
    fit: 'cover',
    start: 0,
    duration: 9,
  },
  {
    src: 'https://pub-31f3fe711bc94b628336fabf982e45f8.r2.dev/home-video/movie5.mp4',
    start: 0,
    duration: 9,
  },
  {
    src: 'https://pub-31f3fe711bc94b628336fabf982e45f8.r2.dev/home-video/movie6.mp4',
    start: 0,
    duration: 9,
  },
];
